/**
 * Safely parses a date string and returns a Date object if valid, otherwise null.
 * @param dateString The date string to parse.
 * @returns A Date object or null.
 */
export const safeParseDate = (
  dateString: string | undefined | null,
): Date | null => {
  if (!dateString) {
    return null
  }
  const date = new Date(dateString)
  if (isNaN(date.getTime())) {
    console.warn(`Invalid time value encountered: "${dateString}"`)
    return null
  }
  return date
}
